import {
  PDP_ADD_TO_CART,
  PDP_VARIANTS_POSITION,
} from 'shared/experiments/consts'
import { isExperimentEnabled } from 'shared/experiments/utils/experiments'
import { bindDynamicEventsTracking } from 'shared/experiments/utils/tracking'

const bindPdpTracking = () =>
  bindDynamicEventsTracking([
    {
      parentElementSelector: '#h_ProductVariants',
      selector: '#AddToCartButton',
      trackingEvent: PDP_ADD_TO_CART,
    },
  ])

export default () => {
  if (!isExperimentEnabled(PDP_VARIANTS_POSITION)) {
    return
  }

  bindPdpTracking()
}
